/* eslint-disable sort-imports-es6-autofix/sort-imports-es6 */
import './assets/vendor.scss';
import './assets/app.scss';
/* eslint-enable sort-imports-es6-autofix/sort-imports-es6 */
import { importSync, isDevelopingApp, macroCondition } from '@embroider/macros';
import Application from '@ember/application';
import Resolver from 'ember-resolver';
import config from './config/environment';
import loadInitializers from 'ember-load-initializers';
import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12';

// NOTE: for full stack testing code coverage
if (typeof FastBoot === 'undefined') {
  if (macroCondition(isDevelopingApp())) {
    let { sendCoverage } = importSync('ember-cli-code-coverage');
    window.sendCoverage = sendCoverage;
  }
}

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver;

  // We can remove this once Ember Inspector supports Ember 4.12+ under Embroider:
  // https://github.com/emberjs/ember-inspector/issues/2612
  inspector = setupInspector(this);
}

loadInitializers(App, config.modulePrefix);
